/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdvertisingCampaignCategoryRowData } from './AdvertisingCampaignCategoryRowData';
import {
    AdvertisingCampaignCategoryRowDataFromJSON,
    AdvertisingCampaignCategoryRowDataFromJSONTyped,
    AdvertisingCampaignCategoryRowDataToJSON,
    AdvertisingCampaignCategoryRowDataToJSONTyped,
} from './AdvertisingCampaignCategoryRowData';
import type { AdvertisingPlatformDestinationRowData } from './AdvertisingPlatformDestinationRowData';
import {
    AdvertisingPlatformDestinationRowDataFromJSON,
    AdvertisingPlatformDestinationRowDataFromJSONTyped,
    AdvertisingPlatformDestinationRowDataToJSON,
    AdvertisingPlatformDestinationRowDataToJSONTyped,
} from './AdvertisingPlatformDestinationRowData';
import type { AdvertisingCategoryDimensionRowData } from './AdvertisingCategoryDimensionRowData';
import {
    AdvertisingCategoryDimensionRowDataFromJSON,
    AdvertisingCategoryDimensionRowDataFromJSONTyped,
    AdvertisingCategoryDimensionRowDataToJSON,
    AdvertisingCategoryDimensionRowDataToJSONTyped,
} from './AdvertisingCategoryDimensionRowData';
import type { AdvertisingDomainOverviewRowData } from './AdvertisingDomainOverviewRowData';
import {
    AdvertisingDomainOverviewRowDataFromJSON,
    AdvertisingDomainOverviewRowDataFromJSONTyped,
    AdvertisingDomainOverviewRowDataToJSON,
    AdvertisingDomainOverviewRowDataToJSONTyped,
} from './AdvertisingDomainOverviewRowData';
import type { AdvertisingFormatDailyRowData } from './AdvertisingFormatDailyRowData';
import {
    AdvertisingFormatDailyRowDataFromJSON,
    AdvertisingFormatDailyRowDataFromJSONTyped,
    AdvertisingFormatDailyRowDataToJSON,
    AdvertisingFormatDailyRowDataToJSONTyped,
} from './AdvertisingFormatDailyRowData';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';
import type { MediaSourceQuality } from './MediaSourceQuality';
import {
    MediaSourceQualityFromJSON,
    MediaSourceQualityFromJSONTyped,
    MediaSourceQualityToJSON,
    MediaSourceQualityToJSONTyped,
} from './MediaSourceQuality';
import type { AdvertisingCampaignStrategyRowData } from './AdvertisingCampaignStrategyRowData';
import {
    AdvertisingCampaignStrategyRowDataFromJSON,
    AdvertisingCampaignStrategyRowDataFromJSONTyped,
    AdvertisingCampaignStrategyRowDataToJSON,
    AdvertisingCampaignStrategyRowDataToJSONTyped,
} from './AdvertisingCampaignStrategyRowData';
import type { AdvertisingFormatOverviewRowData } from './AdvertisingFormatOverviewRowData';
import {
    AdvertisingFormatOverviewRowDataFromJSON,
    AdvertisingFormatOverviewRowDataFromJSONTyped,
    AdvertisingFormatOverviewRowDataToJSON,
    AdvertisingFormatOverviewRowDataToJSONTyped,
} from './AdvertisingFormatOverviewRowData';

/**
 * 
 * @export
 * @interface AdvertisingFormatOverviewData
 */
export interface AdvertisingFormatOverviewData {
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdvertisingFormatOverviewData
     */
    spend?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdvertisingFormatOverviewData
     */
    campaignSpend?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdvertisingFormatOverviewData
     */
    classifiedSpend?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingFormatOverviewData
     */
    adCount?: number;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingFormatOverviewData
     */
    classifiedAdCount?: number;
    /**
     * 
     * @type {Array<AdvertisingFormatOverviewRowData>}
     * @memberof AdvertisingFormatOverviewData
     */
    categories?: Array<AdvertisingFormatOverviewRowData>;
    /**
     * 
     * @type {Array<AdvertisingFormatOverviewRowData>}
     * @memberof AdvertisingFormatOverviewData
     */
    destinations?: Array<AdvertisingFormatOverviewRowData>;
    /**
     * 
     * @type {Array<AdvertisingFormatOverviewRowData>}
     * @memberof AdvertisingFormatOverviewData
     */
    campaignMix?: Array<AdvertisingFormatOverviewRowData>;
    /**
     * 
     * @type {Array<AdvertisingFormatDailyRowData>}
     * @memberof AdvertisingFormatOverviewData
     */
    dailyCategories?: Array<AdvertisingFormatDailyRowData>;
    /**
     * 
     * @type {Array<AdvertisingPlatformDestinationRowData>}
     * @memberof AdvertisingFormatOverviewData
     */
    platformDestinations?: Array<AdvertisingPlatformDestinationRowData>;
    /**
     * 
     * @type {Array<AdvertisingDomainOverviewRowData>}
     * @memberof AdvertisingFormatOverviewData
     */
    domains?: Array<AdvertisingDomainOverviewRowData>;
    /**
     * 
     * @type {Array<AdvertisingFormatDailyRowData>}
     * @memberof AdvertisingFormatOverviewData
     */
    dailyDomains?: Array<AdvertisingFormatDailyRowData>;
    /**
     * 
     * @type {Array<AdvertisingCategoryDimensionRowData>}
     * @memberof AdvertisingFormatOverviewData
     */
    categoryPlatforms?: Array<AdvertisingCategoryDimensionRowData>;
    /**
     * 
     * @type {Array<AdvertisingCategoryDimensionRowData>}
     * @memberof AdvertisingFormatOverviewData
     */
    categoryDomains?: Array<AdvertisingCategoryDimensionRowData>;
    /**
     * 
     * @type {Array<AdvertisingCampaignStrategyRowData>}
     * @memberof AdvertisingFormatOverviewData
     */
    campaignStrategies?: Array<AdvertisingCampaignStrategyRowData>;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingFormatOverviewData
     */
    campaignStrategyTotalCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AdvertisingFormatOverviewData
     */
    campaignStrategiesTruncated?: boolean;
    /**
     * 
     * @type {Array<AdvertisingCampaignCategoryRowData>}
     * @memberof AdvertisingFormatOverviewData
     */
    campaignCategories?: Array<AdvertisingCampaignCategoryRowData>;
    /**
     * 
     * @type {MediaSourceQuality}
     * @memberof AdvertisingFormatOverviewData
     */
    mediaSourceQuality?: MediaSourceQuality;
    /**
     * 
     * @type {AdvertisingFormatOverviewDataFinanceScopeEnum}
     * @memberof AdvertisingFormatOverviewData
     */
    financeScope?: AdvertisingFormatOverviewDataFinanceScopeEnum;
}


/**
 * @export
 */
export const AdvertisingFormatOverviewDataFinanceScopeEnum = {
    RawProvider: 'raw_provider'
} as const;
export type AdvertisingFormatOverviewDataFinanceScopeEnum = typeof AdvertisingFormatOverviewDataFinanceScopeEnum[keyof typeof AdvertisingFormatOverviewDataFinanceScopeEnum];


/**
 * Check if a given object implements the AdvertisingFormatOverviewData interface.
 */
export function instanceOfAdvertisingFormatOverviewData(value: object): value is AdvertisingFormatOverviewData {
    return true;
}

export function AdvertisingFormatOverviewDataFromJSON(json: any): AdvertisingFormatOverviewData {
    return AdvertisingFormatOverviewDataFromJSONTyped(json, false);
}

export function AdvertisingFormatOverviewDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdvertisingFormatOverviewData {
    if (json == null) {
        return json;
    }
    return {
        
        'spend': json['spend'] == null ? undefined : MoneyOutputFromJSON(json['spend']),
        'campaignSpend': json['campaignSpend'] == null ? undefined : MoneyOutputFromJSON(json['campaignSpend']),
        'classifiedSpend': json['classifiedSpend'] == null ? undefined : MoneyOutputFromJSON(json['classifiedSpend']),
        'adCount': json['adCount'] == null ? undefined : json['adCount'],
        'classifiedAdCount': json['classifiedAdCount'] == null ? undefined : json['classifiedAdCount'],
        'categories': json['categories'] == null ? undefined : ((json['categories'] as Array<any>).map(AdvertisingFormatOverviewRowDataFromJSON)),
        'destinations': json['destinations'] == null ? undefined : ((json['destinations'] as Array<any>).map(AdvertisingFormatOverviewRowDataFromJSON)),
        'campaignMix': json['campaignMix'] == null ? undefined : ((json['campaignMix'] as Array<any>).map(AdvertisingFormatOverviewRowDataFromJSON)),
        'dailyCategories': json['dailyCategories'] == null ? undefined : ((json['dailyCategories'] as Array<any>).map(AdvertisingFormatDailyRowDataFromJSON)),
        'platformDestinations': json['platformDestinations'] == null ? undefined : ((json['platformDestinations'] as Array<any>).map(AdvertisingPlatformDestinationRowDataFromJSON)),
        'domains': json['domains'] == null ? undefined : ((json['domains'] as Array<any>).map(AdvertisingDomainOverviewRowDataFromJSON)),
        'dailyDomains': json['dailyDomains'] == null ? undefined : ((json['dailyDomains'] as Array<any>).map(AdvertisingFormatDailyRowDataFromJSON)),
        'categoryPlatforms': json['categoryPlatforms'] == null ? undefined : ((json['categoryPlatforms'] as Array<any>).map(AdvertisingCategoryDimensionRowDataFromJSON)),
        'categoryDomains': json['categoryDomains'] == null ? undefined : ((json['categoryDomains'] as Array<any>).map(AdvertisingCategoryDimensionRowDataFromJSON)),
        'campaignStrategies': json['campaignStrategies'] == null ? undefined : ((json['campaignStrategies'] as Array<any>).map(AdvertisingCampaignStrategyRowDataFromJSON)),
        'campaignStrategyTotalCount': json['campaignStrategyTotalCount'] == null ? undefined : json['campaignStrategyTotalCount'],
        'campaignStrategiesTruncated': json['campaignStrategiesTruncated'] == null ? undefined : json['campaignStrategiesTruncated'],
        'campaignCategories': json['campaignCategories'] == null ? undefined : ((json['campaignCategories'] as Array<any>).map(AdvertisingCampaignCategoryRowDataFromJSON)),
        'mediaSourceQuality': json['mediaSourceQuality'] == null ? undefined : MediaSourceQualityFromJSON(json['mediaSourceQuality']),
        'financeScope': json['financeScope'] == null ? undefined : json['financeScope'],
    };
}

export function AdvertisingFormatOverviewDataToJSON(json: any): AdvertisingFormatOverviewData {
    return AdvertisingFormatOverviewDataToJSONTyped(json, false);
}

export function AdvertisingFormatOverviewDataToJSONTyped(value?: AdvertisingFormatOverviewData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'spend': MoneyOutputToJSON(value['spend']),
        'campaignSpend': MoneyOutputToJSON(value['campaignSpend']),
        'classifiedSpend': MoneyOutputToJSON(value['classifiedSpend']),
        'adCount': value['adCount'],
        'classifiedAdCount': value['classifiedAdCount'],
        'categories': value['categories'] == null ? undefined : ((value['categories'] as Array<any>).map(AdvertisingFormatOverviewRowDataToJSON)),
        'destinations': value['destinations'] == null ? undefined : ((value['destinations'] as Array<any>).map(AdvertisingFormatOverviewRowDataToJSON)),
        'campaignMix': value['campaignMix'] == null ? undefined : ((value['campaignMix'] as Array<any>).map(AdvertisingFormatOverviewRowDataToJSON)),
        'dailyCategories': value['dailyCategories'] == null ? undefined : ((value['dailyCategories'] as Array<any>).map(AdvertisingFormatDailyRowDataToJSON)),
        'platformDestinations': value['platformDestinations'] == null ? undefined : ((value['platformDestinations'] as Array<any>).map(AdvertisingPlatformDestinationRowDataToJSON)),
        'domains': value['domains'] == null ? undefined : ((value['domains'] as Array<any>).map(AdvertisingDomainOverviewRowDataToJSON)),
        'dailyDomains': value['dailyDomains'] == null ? undefined : ((value['dailyDomains'] as Array<any>).map(AdvertisingFormatDailyRowDataToJSON)),
        'categoryPlatforms': value['categoryPlatforms'] == null ? undefined : ((value['categoryPlatforms'] as Array<any>).map(AdvertisingCategoryDimensionRowDataToJSON)),
        'categoryDomains': value['categoryDomains'] == null ? undefined : ((value['categoryDomains'] as Array<any>).map(AdvertisingCategoryDimensionRowDataToJSON)),
        'campaignStrategies': value['campaignStrategies'] == null ? undefined : ((value['campaignStrategies'] as Array<any>).map(AdvertisingCampaignStrategyRowDataToJSON)),
        'campaignStrategyTotalCount': value['campaignStrategyTotalCount'],
        'campaignStrategiesTruncated': value['campaignStrategiesTruncated'],
        'campaignCategories': value['campaignCategories'] == null ? undefined : ((value['campaignCategories'] as Array<any>).map(AdvertisingCampaignCategoryRowDataToJSON)),
        'mediaSourceQuality': MediaSourceQualityToJSON(value['mediaSourceQuality']),
        'financeScope': value['financeScope'],
    };
}

